// TODO: This file was used on the old deprecated cache, consider removing it
// Instead of creating a new constant here consider using the api path constant directly to avoid duplication.

export const CACHE_NAME = 'insightt-api-cache';
export const ACTIVE_SHIFT_OVERVIEW = () => 'api-shift-admin-active-shifts-overview';
export const SPOTTER_BY_RANK = (dateStart, dateEnd, timezoneOffset) =>
  `api-reports-spotters-by-rank?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

export const AGENTS_BY_RANK = (dateStart, dateEnd, timezoneOffset) =>
  `api-reports-agents-by-rank?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

export const DAILY_REPORTS = (date, timezoneOffset, branchId) =>
  `api-reports-daily-report?date=${date}&timezoneOffset=${timezoneOffset}&branchId=${branchId}`;

export const REPORTS_COMPANY_2_YEARS = (year, timezoneOffset) =>
  `api-reports-company-2-years?year=${year}&timezoneOffset=${timezoneOffset}`;

export const REPORTS_CLIENT_BY_RANK = (currentDate, timezoneOffset, dateStart, dateEnd) =>
  `api-reports-clients-by-rank?year=${currentDate}&timezoneOffset=${timezoneOffset}&${dateStart}&dateEnd=${dateEnd}`;

export const CAMERA_BY_RANK = (dateStart, dateEnd, timezoneOffset) =>
  `api-reports-cameras-by-rank?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

export const ACTIVE_SHIFT_ALERTS_FEED = (page, limit, branchId) =>
  `api-shift-admin-alerts-feed?page=${page}&limit=${limit}&branchId=${branchId}`;

export const CUSTOM_COMMISSIONS = (page, limit, branchId) =>
  `api-commissions-custom-commissions?page=${page}&limit=${limit}&branchId=${branchId}`;

export const DELETE_ACTIVE_SHIFT_ALERTS_FEED = () => 'api-shift-admin-alerts-feed?';

export const DELETE_CUSTOM_COMMISSIONS = () => 'api-commissions-custom-commissions?';
